const e = [
  1,
  1.2,
  1.3
];
e.headingHugeDesktop = e[0];
e.headingLargeDesktop = e[0];
e.headingMediumDesktop = e[1];
e.headingSmallDesktop = e[1];
e.headingXsmallDesktop = e[1];
e.textLargeDesktop = e[1];
e.textMediumDesktop = e[2];
e.textSmallDesktop = e[2];
e.textXsmallDesktop = e[2];
e.headingHugeMobile = e[0];
e.headingLargeMobile = e[0];
e.headingMediumMobile = e[1];
e.headingSmallMobile = e[2];
e.headingXsmallMobile = e[2];
e.textLargeMobile = e[2];
e.textMediumMobile = e[2];
e.textSmallMobile = e[2];
e.textXsmallMobile = e[2];
export {
  e as default
};
